// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1214":"dab83787","2444":"241b1a03","5678":"dab83787","6815":"dab83787","7460":"4f6468e3"}[chunkId] + ".chunk.css";
};